import { checkHttpStatus, parseJSON, parseJSONResponse, objectToQueryString, expiredToken } from '../../utils/response'
import { Token, UserCode, EmployeeId, Company } from '../../utils/users'
import { errorResponse } from '../../utils/response'
import { IsEnglish, GetLanguage } from '../../utils/language'
import * as statusRequest from '../../scripts/LeaveRequestStatusCode'
import i18next from 'i18next';

export function addLeaveRequest(startDate, endDate, durationTypeId, duration, comment, isPartial, payCode, returnDate, startTime, endTime) {
    return fetch('request/saveLeave', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            company: Company(),
            employeeId: EmployeeId(),
            language: GetLanguage(),
            startDate: startDate,
            endDate: endDate,
            durationTypeId: durationTypeId,
            duration: duration,
            comment: comment,
            isPartial: isPartial,
            payCode: payCode,
            returnDate: returnDate,
            startTime: startTime,
            endTime: endTime,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function addVacationRequest(startDate, endDate, durationTypeId, duration, comment, isPartial, IsPayAdvance, datePay, returnDate, startTime, endTime) {
    return fetch('request/saveVacation', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            company: Company(),
            employeeId: EmployeeId(),
            language: GetLanguage(),
            startDate: startDate,
            endDate: endDate,
            durationTypeId: durationTypeId,
            duration: duration,
            comment: comment,
            isPartial: isPartial,
            isPayAdvance: IsPayAdvance,
            datePay: datePay,
            returnDate: returnDate,
            startTime: startTime,
            endTime: endTime,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function cancelRequest(centralApprovalId, status, isApproved) {
    return fetch('request/cancelRequest', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            centralApprovalId: centralApprovalId,
            status: status,
            isApproved: isApproved,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getAllListsPage() {
    let url = 'Request/getAllListsPage?' + objectToQueryString({ userCode: UserCode(), employeeId: EmployeeId(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getListDatePay(startDate, endDate) {
    let url = 'Request/getListDatePay?' + objectToQueryString({ userCode: UserCode(), employeeId: EmployeeId(), startDate: startDate, endDate: endDate, token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getListRequest(status, requestTypes, topSelect = 0) {
    let url = 'Request/getListRequest?' + objectToQueryString({ userCode: UserCode(), employeeId: EmployeeId(), company: Company(), status: status, requestTypes: requestTypes, token: Token(), topSelect: topSelect });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortList(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.descriptionEn.toLowerCase() : a.descriptionFr.toLowerCase()
        const nameB = IsEnglish() ? b.descriptionEn.toLowerCase() : b.descriptionFr.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortListByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.value
        const nameB = b.value
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function getStatusDescription(status) {
    switch (status) {
        case statusRequest.Status_Opened:
            return i18next.t("request:status.opened");
        case statusRequest.Status_Close:
            return i18next.t("request:status.closed");
        case statusRequest.Status_Canceled:
            return i18next.t("request:status.canceled");
        case statusRequest.Status_Cancel_Request:
            return i18next.t("request:status.cancelationRequest");
        default:
            return "";
    }
}